<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  beforeDestroy() {},
  methods: {}
};
</script>
<style lang="scss">
// @import "./common/font/notosans.css";
// body {
//   font-family: 'Noto Sans SC', sans-serif;
// }
</style>